export default __webpack_public_path__ + "static/media/dashboard-line.e12980f9.svg";